import {DataObjectId, Hub, movementTemplatesContainerId} from 'yougile-model'
import {globals} from '@extensions/globals-base'
import {Sync} from './sync'

export class MovementClient {
  public static hasFeature(): boolean {
    const box = Sync.get({companyId: globals.getCompanyId()})
    const container = box.get(movementTemplatesContainerId)
    return !!container
  }

  public static listAllTemplates(companyId: DataObjectId): Hub[] {
    if (!this.hasFeature()) {
      return []
    }

    const box = Sync.get({companyId})

    const all = box.getChildrenHubs(movementTemplatesContainerId)
    return [...all].reverse()
  }

  public static listTemplatesInBoard(boardId: DataObjectId): Hub[] {
    const box = Sync.getCurrentSandbox()
    const board = box.getHub(boardId)
    if (!board) {
      return []
    }

    const all = MovementClient.listAllTemplates(board.companyId)

    return all.filter(h => {
      if (!h || h.deleted) {
        return false
      }

      return h.data?.movementTemplate?.boardId === board.id
    })
  }

  public static listTemplatesInColumn(
    boardId: DataObjectId,
    columnId: DataObjectId
  ): Hub[] {
    const templates = this.listTemplatesInBoard(boardId)

    return this.filterTemplateForColumn(templates, columnId)
  }

  public static listTemplatesInColumnEnabled(
    boardId: DataObjectId,
    columnId: DataObjectId
  ): Hub[] {
    return this.listTemplatesInColumn(boardId, columnId).filter(
      t => t.data.movementTemplate.enabled
    )
  }

  public static filterTemplateForColumn(
    templates: Hub[],
    columnId: DataObjectId
  ): Hub[] {
    return templates.filter(tmpl => {
      const data = tmpl?.data?.movementTemplate
      if (!data) {
        return false
      }

      if (data.moveFromColumnsAllIn) {
        return true
      }

      return data.moveFromColumns.includes(columnId)
    })
  }
}
